module.exports = __webpack_public_path__ + "img/ic_new-bin.78e85662.svg";